/* unplugin-vue-components disabled */import { render } from "./ItemsMatching.vue?vue&type=template&id=5b84370a&scoped=true&ts=true"
import script from "./ItemsMatching.vue?vue&type=script&lang=ts"
export * from "./ItemsMatching.vue?vue&type=script&lang=ts"

import "./ItemsMatching.vue?vue&type=style&index=0&id=5b84370a&lang=scss&scoped=true"
import "./ItemsMatching.vue?vue&type=style&index=1&id=5b84370a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b84370a"]])

export default __exports__